import { useSearchParams } from '@funtech-int/rival-react';
import { SportPromoSelection } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { DEFAULT_SPORT_EVENT_ID_PARAM } from './useSportPromoLoginUrl';

export const useSportPromoInitialIndex = (selection: SportPromoSelection) => {
    const searchParams = useSearchParams();
    const defaultEventId = searchParams?.get(DEFAULT_SPORT_EVENT_ID_PARAM);

    if (!defaultEventId) {
        return 0;
    }

    return selection.items.findIndex((item) => item.id === defaultEventId) || 0;
};
